import { cn } from '@/lib/utils';

import { ResizeSeparatorProps } from './useResizablePanel';

interface ResizeHandleProps {
  separatorProps: ResizeSeparatorProps;
  /** True while the handle is hovered or dragged — drives the accent styling. */
  isActive: boolean;
  label: string;
  /** Which edge of the parent the handle sits on. Defaults to 'right'. */
  side?: 'left' | 'right';
  className?: string;
}

/**
 * Styled drag handle for a resizable panel. Pair with {@link useResizablePanel}:
 * spread its `separatorProps` and pass its `isActive` flag.
 */
export const ResizeHandle = ({
  separatorProps,
  isActive,
  label,
  side = 'right',
  className,
}: ResizeHandleProps) => (
  <div
    {...separatorProps}
    aria-label={label}
    className={cn(
      'absolute inset-y-0 z-10 w-px cursor-col-resize touch-none bg-border transition-colors duration-150 ease-out before:pointer-events-auto before:absolute before:inset-0 before:-mx-[4.5px] before:w-[10px] before:content-[""] focus-visible:ring-1 focus-visible:ring-ring focus-visible:ring-offset-1 focus-visible:outline-hidden',
      side === 'right' ? 'right-0' : 'left-0',
      isActive && 'w-[2px] bg-accent',
      className
    )}
  />
);
